<template>
  <div class="mp3-list">
    <div class="top-section">
      <div class="mp3-category">
        <div class="content">
          <el-tag type="info" :class="{ active: tag === '' && !showMyBlog }" @click="handleTagClick('')">全部</el-tag>
          <el-tag v-for="item in tagList" :key="item.id" type="info" :class="{ active: tag === item.id && !showMyBlog }"
            @click="handleTagClick(item.id)">{{ item.name }}</el-tag>
          <el-tag v-if="isLoggedIn" type="info" :class="{ active: showMyBlog }" @click="handleMyBlogClick">我的博客</el-tag>
        </div>
        <div class="search-area">
          <div class="search">
            <el-input
              prefix-icon="el-icon-search"
              v-model:value="keyword"
              @keyup.enter.native="handleSearch"
              placeholder="输入关键词进行搜素" />
          </div>
          <div v-if="isLoggedIn" class="upload-section">
            <el-button type="primary" size="small" icon="el-icon-plus" circle @click="showUploadDialog"></el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mp3-list-content infinite-list"
      v-infinite-scroll="getMp3List"
      :infinite-scroll-disabled="disabled"
      style="overflow:auto">
      <div class="mp3-list-item" v-for="(item, index) in mp3List" :key="item.id"
        :class="{ active: currentIdx === index }" @click="handleItemClick(index)">
        <div class="left-con">
          <el-tooltip class="item" :content="item.title" placement="top">
            <h3 class="title">{{ item.title }}</h3>
          </el-tooltip>
          <p class="time">{{ item.ai_mp3_duration }}</p>
          <p class="visits" :class="{ 'active-visits': currentIdx === index }">播放次数: {{ item.visits || 0 }}</p>
          <img class="like" v-if="item.is_like" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/like.png"
            @click="toLike(item, index)">
          <img class="like" v-else src="https://chrome1.oss-cn-shanghai.aliyuncs.com/like.png"
            @click.stop="toLike(item, index)" />
          <div class="media-type-badge">
            <el-tag v-if="item.ai_mp3_type === 5" type="success" size="mini">视频</el-tag>
            <el-tag v-else type="info" size="mini">音频</el-tag>
          </div>
        </div>
        <div class="right-con">
          <div class="cover">
            <img :src="item.ai_image" alt="mp3">
          </div>
        </div>
      </div>
      <div v-if="!mp3List.length" class="empty-con">
        <el-empty :image-size="200"></el-empty>
      </div>
    </div>

    <div class="mp3-player">
      <i class="el-icon-video-play" @click="handlePlay" v-if="!playing" />
      <i class="el-icon-video-pause" @click="handlePause" v-else />
      <div class="player-con">
        <span>{{ formatTime(currentTime) }}</span>
        <el-slider v-model="currentTime" :max="duration" @change="updateTime"></el-slider>
        <span>{{ formatTime(duration) }}</span>
      </div>
    </div>

    <el-dialog title="生成博客" :visible.sync="uploadDialogVisible" width="500px">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadForm" label-width="100px">
        <el-form-item label="博客标题" prop="title">
          <el-input v-model="uploadForm.title" placeholder="请输入博客标题"></el-input>
        </el-form-item>
        <el-form-item label="文章链接" prop="url">
          <el-input v-model="uploadForm.url" placeholder="请输入文章链接"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="uploading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 视频播放弹出框 -->
    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="80%" :before-close="handleVideoClose">
      <div class="video-container">
        <video 
          ref="videoPlayer"
          :src="currentVideoUrl" 
          controls 
          autoplay
          @loadedmetadata="onVideoLoaded"
          @timeupdate="onVideoTimeUpdate"
          @ended="onVideoEnded"
          style="width: 100%; height: 500px;">
          您的浏览器不支持视频播放。
        </video>
        <div class="video-info" v-if="currentVideoItem">
          <h3>{{ currentVideoItem.title }}</h3>
          <p>播放次数: {{ currentVideoItem.visits || 0 }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/http/request';

let timer = null
export default {
  data () {
    return {
      keyword: '',
      audioCon: null,
      time: 0,
      activeItem: null,
      mp3List: [],
      tagList: [],
      oldIdx: null,
      currentIdx: 0,
      currentTime: 0,
      duration: 0,
      playing: false,
      tag: '',
      page: 1,
      disabled: false,
      uploadDialogVisible: false,
      uploadForm: {
        title: '',
        url: '',
      },
      uploadRules: {
        title: [
          { required: true, message: '请输入博客标题', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入文章链接', trigger: 'blur' }
        ]
      },
      uploading: false,
      showMyBlog: false,
      requestId: 0, // 用于标识请求，解决竞态条件问题
      videoDialogVisible: false, // 视频播放弹出框显示状态
      currentVideoUrl: '', // 当前播放的视频URL
      currentVideoItem: null, // 当前播放的视频项目信息
    }
  },
  props: ['rightExpanded'],
  computed: {
    isLoggedIn() {
      // 判断用户是否登录
      const userInfo = localStorage.getItem('userinfo')
      const authorization = localStorage.getItem('authorization')
      return !!(userInfo && authorization)
    }
  },
  watch: {
    rightExpanded (val) {
      if (val) {
        this.handlePause()
      }
    }
  },
  methods: {
    toLike (item, idx) {
      request('/api/Wechatarticle/updateArticleLike', {
        article_id: item.id,
        like_status: item.is_like ? 0 : 1
      }).then((res) => {
        this.$message.success(item.is_like ? '取消点赞' : '点赞成功')
        this.mp3List[idx].is_like = item.is_like ? 0 : 1
      })
    },
    updateTime (value) {
      this.currentTime = value
      this.audioCon.currentTime = this.currentTime
    },
    handleItemClick (index) {
      const currentItem = this.mp3List[index]
      
      // 判断是视频还是音频
      if (currentItem.ai_mp3_type === 5) {
        // 是视频，直接打开视频播放弹出框
        this.showVideoDialog(currentItem)
        this.currentIdx = index
        this.oldIdx = index
      } else {
        // 是音频，执行原有的播放逻辑
        if (index === this.currentIdx) return
        this.currentIdx = index
        this.oldIdx = index
        this.audioCon.src = currentItem.ai_mp3
        // this.$emit('setMp3Url', this.mp3List[index])
        this.handlePlay()
      }
    },
    formatTime (time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    handlePlay () {
      // 如果视频弹出框打开，先关闭视频
      if (this.videoDialogVisible) {
        this.handleVideoClose();
      }
      
      this.playing = true
      if (!this.audioCon.src) {
        this.audioCon.src = this.mp3List[this.currentIdx].ai_mp3
      }
      this.audioCon.play()
      this.updateArticleVisits(this.mp3List[this.currentIdx])
    },
    handlePause () {
      this.playing = false
      this.audioCon.pause()
      clearTimeout(timer)
    },
    clearTag () {
      this.tag = ''
      this.page = 1
      this.disabled = true // 立即禁用无限滚动
      this.mp3List = [] // 清空列表
      this.requestId++ // 增加请求ID
      this.getMp3List()
    },
    handleTagClick(tag) {
      this.page = 1
      this.tag = tag
      this.showMyBlog = false // 重置我的博客状态
      this.mp3List = [] // 清空列表
      this.requestId++ // 增加请求ID
      this.disabled = false // 先设置为false，让getMp3List能够执行
      this.getMp3List()
    },
    
    handleMyBlogClick() {
      this.showMyBlog = true;
      this.page = 1;
      this.tag = ''; // 重置标签选择
      this.keyword = ''; // 重置搜索关键词
      this.mp3List = []; // 清空列表
      this.requestId++; // 增加请求ID
      this.disabled = false; // 先设置为false，让getMp3List能够执行
      this.getMp3List();
    },
    
    handleSearch() {
      this.page = 1
      this.showMyBlog = false // 重置我的博客状态
      this.mp3List = [] // 清空列表
      this.requestId++ // 增加请求ID
      this.disabled = false // 先设置为false，让getMp3List能够执行
      this.getMp3List()
    },
    getMp3List () {
      // 如果已经禁用无限滚动，则不再加载数据
      if (this.disabled) {
        return;
      }
      
      // 加载时先禁用无限滚动，防止重复触发
      this.disabled = true;
      
      const params = {
         page: this.page,
         limit: 20,
         search: this.keyword,
         tag: this.tag
      };
      
      if (this.showMyBlog) {
        params.is_self = 1;
      }
      
      const currentRequestId = this.requestId; // 保存当前请求ID
      
      request('/api/Wechatarticle/getGoodArticleList', params, 'get').then(res => {
        // 检查请求ID是否匹配，如果不匹配说明是过期的请求
        if (currentRequestId !== this.requestId) {
          return; // 忽略过期的请求
        }
        
        this.tagList = res.tag_list
        
        // 如果返回的数据少于请求的数量，说明已经到底了
        if (res.article_list.length < 20) {
          this.disabled = true
        } else {
          // 否则，启用无限滚动，允许加载更多
          this.disabled = false
        }
        
        if (this.page === 1) {
          this.mp3List = res.article_list
          if (this.mp3List.length > 0) {
            // 找到第一个音频内容进行初始化
            const firstAudioItem = this.mp3List.find(item => item.ai_mp3_type !== 5)
            if (firstAudioItem) {
              this.audioCon.src = firstAudioItem.ai_mp3
              this.$emit('setMp3Url', firstAudioItem)
            }
          }
        } else {
          this.mp3List = this.mp3List.concat(res.article_list)
        }
        this.page += 1
      }).catch(error => {
        // 检查请求ID是否匹配
        if (currentRequestId !== this.requestId) {
          return; // 忽略过期的请求错误
        }
        console.error('获取数据失败:', error);
        // 出错时也需要重置状态
        this.disabled = false;
      })
    },
    updateArticleVisits(item) {
      request('/api/Wechatarticle/updateArticleVisits', {
        article_id: item.id
      }).then((res) => {
        const currentItem = this.mp3List.find(mp3Item => mp3Item.id === item.id)
        if (currentItem) {
          currentItem.visits = (currentItem.visits || 0) + 1
        }
      }).catch((error) => {
        console.error('更新播放次数失败:', error)
      })
    },
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },
    cancelUpload() {
      this.uploadDialogVisible = false;
      // 重置表单
      this.uploadForm.title = '';
      this.uploadForm.url = '';
      this.$refs.uploadForm.resetFields();
    },
    submitUpload() {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          this.uploading = true;
          request('/api/Wechatarticle/generateAiMp3', {
            title: this.uploadForm.title,
            url: this.uploadForm.url
          }).then((res) => {
            this.$message.success('上传成功，请等待审核');
            this.uploadDialogVisible = false;
            this.uploading = false;
            // 重置表单
            this.uploadForm.title = '';
            this.uploadForm.url = '';
            this.$refs.uploadForm.resetFields();
          }).catch((error) => {
            this.$message.error('上传失败，请重试');
            this.uploading = false;
          });
        }
      });
    },
    
    // 视频播放相关方法
    showVideoDialog(item) {
      // 如果音频正在播放，先停止音频
      if (this.playing && this.audioCon) {
        this.handlePause();
      }
      
      this.currentVideoItem = item;
      this.currentVideoUrl = item.ai_mp3; // 视频URL也存储在ai_mp3字段中
      this.videoDialogVisible = true;
      this.updateArticleVisits(item); // 更新播放次数
    },
    
    handleVideoClose() {
      this.videoDialogVisible = false;
      this.currentVideoUrl = '';
      this.currentVideoItem = null;
      // 暂停视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },
    
    onVideoLoaded() {
      // 视频加载完成后的处理
      console.log('视频加载完成');
    },
    
    onVideoTimeUpdate() {
      // 视频播放时间更新时的处理
      // 这里可以添加进度跟踪等功能
    },
    
    onVideoEnded() {
      // 视频播放结束时的处理
      console.log('视频播放结束');
      // 可以在这里添加自动播放下一个视频的逻辑
    },
  },
  mounted () {
    this.audioCon = document.createElement('audio')
    
    // 确保初始加载时不会重复请求
    this.disabled = false
    this.getMp3List()

    this.audioCon.addEventListener('ended', () => {
      this.oldIdx = null
      // 寻找下一个音频内容
      let nextIndex = this.currentIdx + 1
      while (nextIndex < this.mp3List.length && this.mp3List[nextIndex].ai_mp3_type === 5) {
        nextIndex++
      }
      if (nextIndex < this.mp3List.length) {
        this.handleItemClick(nextIndex)
      }
    })

    this.audioCon.addEventListener('loadedmetadata', () => {
      this.duration = this.audioCon.duration
    })
    this.audioCon.addEventListener('timeupdate', () => {
      this.currentTime = this.audioCon.currentTime
    })
  }
}
</script>

<style lang="scss" scoped>
.mp3-list {
  width: 90%;
  min-width: 1200px;
  margin: 40px auto 0;
  position: relative;
  overflow: auto;

  .mp3-category {
    display: flex;
    gap: 10px;
    flex: 1;
    align-items: center;
    margin-bottom: 20px;
    .content{
      display: flex;
      gap: 12px;
      flex-shrink: 0;
    }
    .search-area {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      margin-left: 20px;
    }
    .search{
      width: 200px;
      flex-shrink: 0;
      :deep(.el-input__inner) {
        height: 32px;
        line-height: 32px;
      }
      :deep(.el-input__icon) {
        line-height: 32px;
      }
    }

    .upload-section {
      display: flex;
      align-items: center;
    }

    .el-tag {
      cursor: pointer;
    }

    .active {
      background-color: rgba(255, 0, 0, 0.654);
      color: #fff;
    }

    .el-icon-circle-close {
      cursor: pointer;
      color: #999;
      position: relative;
      top: 8px;
    }
  }
}

.mp3-list-content {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 12px;
  overflow: auto;
  padding-bottom: 60px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
  }



  .mp3-list-item {
    background-color: #1d6ac85e;
    border-color: rgba(6, 7, 9, 0.1);
    border-radius: 8px;
    padding: 12px;
    width: 22%;
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 140px;
    border: 2px solid transparent;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .04), 0 4px 12px 0 rgba(0, 0, 0, .02);

    &.active {
      border: 2px solid rgb(217, 112, 112);
    }

    &:hover {
      box-shadow: 0 8px 24px 0 rgba(0, 0, 0, .16), 0 16px 48px 0 rgba(0, 0, 0, .08);
    }
  }

  .left-con {
    width: calc(100% - 160px);

    .title {
      cursor: pointer;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      /* 限制在一个块元素显示的文本的行数 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      font-size: 14px;
      overflow: hidden;
      /* 超出部分隐藏 */
      text-overflow: ellipsis;
      /* 超出部分显示省略号 */
    }

    .time {
      margin-top: 10px;
      color: #999;
    }

    .visits {
      margin-top: 10px;
      color: #999;
      font-size: 12px;
      
      &.active-visits {
        color: rgb(217, 112, 112);
        font-weight: 600;
      }
    }

    .like {
      width: 20px;
      height: 20px;
      position: absolute;
      left: 10px;
      bottom: 10px;
      cursor: pointer;
    }
  }

  .right-con {
    background-color: #fff;
    border-radius: 8px;
    width: 50%;
    position: absolute;
    right: 10px;
    top: 10px;

    img {
      width: 100%;
      object-fit: cover;
      height: 140px;
      border-radius: 8px;
      transition: all 0.3s ease;
      cursor: pointer;
    }
  }

  .empty-con {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.mp3-player {
  position: fixed;
  bottom: 30px;
  width: 520px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgb(217, 112, 112);
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 12px;
  border-radius: 12px;

  i {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }

  .player-con {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #fff;
  }

  .el-slider {
    width: 320px;

    :deep(.el-slider__runway) {
      background-color: #fff;
    }

    :deep(.el-slider__bar) {
      background: #FFF;
    }

    :deep(.el-slider__button) {
      border-color: #fff;
    }
  }
}

// 视频播放弹出框样式
.video-container {
  text-align: center;
  
  video {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .video-info {
    margin-top: 20px;
    text-align: left;
    
    h3 {
      margin: 0 0 10px 0;
      font-size: 18px;
      color: #303133;
    }
    
    p {
      margin: 5px 0;
      color: #909399;
      font-size: 14px;
    }
  }
}

// 媒体类型标签样式
.media-type-badge {
  position: absolute;
  left: 35px;
  bottom: 10px;
}
</style>
